import { useRef } from 'react';
import { isEqual } from 'lodash';

export const useDeepCompareMemoize = <T>(value: T): T | undefined => {
  const ref = useRef<T>();

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
};
